import { isNotDefined } from '@sgme/fp';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardPriceButton } from '@/App/tiles/FlexiForward/FlexiForwardTile/FlexiForwardPriceButton/PriceButton.tsx';
import { TimestampButton } from '@/App/tiles/FlexiForward/FlexiForwardTile/TimestampButton.tsx';
import { IsInternalSales } from '@/App/tiles/Option/utils/IsInternalSales.tsx';
import { TraderInfos } from '@/components/TraderInfos.tsx';
import type { FxFlexiForward } from '@/store/flexi-forward/state.ts';

export function FlexiForwardTileFooter({ tileId }: { tileId: string }) {
  return (
    <div className="mt-auto px-8px pt-16px">
      <FlexiForwardPriceButton tileId={tileId} />
      <IsInternalSales>
        <div className="d-flex flex-between">
          <TimestampButton tileId={tileId} />
          <FlexiForwardTradersInfos tileId={tileId} />
        </div>
      </IsInternalSales>
    </div>
  );
}

function FlexiForwardTradersInfos({ tileId }: { tileId: string }) {
  const { contribution, traderId } = useFlexiForwardSelector((flexiForward) => {
    return {
      traderId: getTraderId(flexiForward),
      contribution: getContribution(flexiForward),
    };
  });

  return <TraderInfos contribution={contribution} tileId={tileId} traderId={traderId} />;
}

function getTraderId(flexiForward: FxFlexiForward): string | undefined {
  if (isNotDefined(flexiForward.properties.rfs)) {
    return undefined;
  }

  if (flexiForward.properties.rfs.status !== 'AWAITING' && flexiForward.properties.rfs.status !== 'PRICING') {
    return undefined;
  }

  return flexiForward.properties.rfs.traderId;
}

function getContribution(flexiForward: FxFlexiForward): 'Automatic' | 'Manual' {
  if (isNotDefined(flexiForward)) {
    return 'Manual';
  }

  if (flexiForward.properties.rfs?.status !== 'PRICING' && flexiForward.properties.rfs?.status !== 'EXPIRED') {
    return 'Manual';
  }

  return flexiForward.properties.rfs.quote.contribution;
}
